export default __webpack_public_path__ + "static/24-7-support-2-05164c94f6ac8eec1325d83cb00c1b95.png";